import {
    type PrerenderedCheckoutDeferredAction,
    getPrerenderedCheckoutState,
    setPrerenderedCheckoutDeferredActions,
} from './prerenderedCheckoutStore.ts';

export const deferActionIfInBackground = (action: PrerenderedCheckoutDeferredAction): void => {
    const { rootState } = getPrerenderedCheckoutState();

    if (rootState === 'ENABLED_IN_BACKGROUND') {
        setPrerenderedCheckoutDeferredActions(action);
        return;
    }

    action();
};
